import { selectUsers } from "src/modules/users/selector";
import { useAppSelector } from "./redux";

export function useUsers() {
  const users = useAppSelector((state) => selectUsers(state));

  function getUser(email: string | undefined) {
    if (users && email) {
      const user = users[email];

      return user;
    }

    return null;
  }

  return { users, getUser };
}
